import { Injectable } from '@angular/core';
import { Nationality } from 'src/app/typescript/nationality';

@Injectable({
  providedIn: 'root',
})
export class NationalityHandlerService {
  redirectType: CVRedirectType;
  wantsUnauthLogin = false;
  public redirectToSite() {
    if (window.location.href === 'https://idopontfoglalas.gumiszervizem.hu/') {
      window.location.replace('https://gumiszervizem.hu/');
    } else if (
      window.location.href === 'http://idopontfoglalas.softwaremedial.hu:10437/' ||
      window.location.href === 'https://bd-tst.4dsoft.hu/'
    ) {
      window.location.replace('http://softwaremedial.hu/');
    }
  }

  public setSiteTypeByBaseUrl() {
    this.redirectType = this.returnSiteTypeByBaseUrl();
  }

  private returnSiteTypeByBaseUrl(): CVRedirectType {
    if (window.location.href.includes('gumiszervizem.hu')) {
      return CVRedirectType.PRODHUN;
    } else if (window.location.href.includes('prezujma.sk') || window.location.href.includes('sk')) {
      return CVRedirectType.SK;
    } else if (window.location.href.includes('codevisionkft') && !window.location.href.includes('tst')) {
      return CVRedirectType.DEV;
    } else if (
      window.location.href.includes('codevisionkft') &&
      window.location.href.includes('tst') &&
      !window.location.href.includes('sk')
    ) {
      return CVRedirectType.TSTHUN;
    } else if (window.location.href.includes('http://localhost:4200/')) {
      //for testing purposes
      return CVRedirectType.PRODHUN;
    } else {
      return CVRedirectType.PRODHUN;
    }
  }

  public returnSiteNationality(): Nationality {
    if (window.location.href.includes('localhost')) {
      return Nationality.HUNGARIAN;
    }
    if (
      window.location.href.includes('gumiszervizem.hu') ||
      window.location.href.includes('bd-dev.4dsoft.hu') ||
      window.location.href.includes('bd-tst.4dsoft.hu')
    ) {
      return Nationality.HUNGARIAN;
    } else if (
      window.location.href.includes('prezujma.sk') ||
      window.location.href.includes('bd-sk-dev.4dsoft.hu') ||
      window.location.href.includes('bd-sk-tst.4dsoft.hu')
    ) {
      return Nationality.SLOVAKIAN;
    }
    return Nationality.HUNGARIAN;
  }
}

export enum CVRedirectType {
  PRODHUN = 0,
  SK = 1,
  DEV = 2,
  TST = 3,
  NO_REDIRECT = 4,
  TSTHUN = 5,
}
